import * as types from "./types";
import createReducer from "../../utils/createReducer";
import {
   CREATE_PAGE_SEGMENT_KEY,
} from 'admin/views/site-designer/data';
import initialState from './initial-state';

let reducersMap = {
   // Pages
   [types.FETCH_PAGES_REQUEST]: (state, action) => {
      return {
         ...state,
         leftSideFetching: action.payload,
         rightSideFetching: action.payload,
      }
   },

   [types.FETCH_PAGES_COMPLETED]: (state, action) => {
      const { pages, globalSettings } = action.payload;
      return {
         ...state,
         pagesList: pages,
         globalSettings,
         reservGlobalSettings: structuredClone(globalSettings),

      }
   },
   [types.FETCH_PAGE_BY_ID_REQUEST]: (state, action) => {
      return {
         ...state,
         leftSideFetching: action.payload,
         // currentPage: {},
      }
   },

   [types.FETCH_PAGE_BY_ID_COMPLETED]: (state, action) => {
      const { data, leftFetching } = action.payload;
      return {
         ...state,
         leftSideFetching: leftFetching,
         currentPage: {
            ...data,
         },
         selectedPagesState: {
            ...state.selectedPagesState,
            [data.id]: data,
         },
      }
   },
   [types.SET_CURRENT_PAGE]: (state, action) => {
      const { data, sectionUuid } = action.payload;
      let newState = {
         ...data,
      }
      if(sectionUuid){
         let sections = state.currentPage?.sections || [];
         if(sections.find(section => section.uuid === sectionUuid)){
            sections = sections.map((section) => {
               let { ...elm } = section;
               if(elm.uuid === sectionUuid){
                  elm = {
                     ...elm,
                     ...data,
                  }
               }
               return elm;
            })
         } else {
            sections = [...sections, data];
         }
         newState = {
            sections,
         }
      }
      return {
         ...state,
         savedData: {},
         currentPage: {
            ...state.currentPage,
            ...newState,
         },
      }
   },
   [types.CREATE_PAGE_COMPLETED]: (state, action) => {
      const data = action.payload;
      return {
         ...state,
         fetchSaveAsDraft: false,
         pagesList: [...state.pagesList, data],
         currentPage: data,
      }
   },
   [types.DELETE_PAGE_COMPLETED]: (state, action) => {
      const { id, isDeleted } = action.payload;
      return {
         ...state,
         pagesList: state.pagesList.map(page => {
            const { ...elm } = page
            if(elm.id === id){
               elm.is_deleted = isDeleted ? true : false
            }
            return elm
         }),
      }
   },
   [types.TOGGLE_VISIBILITY_PAGE_COMPLETED]: (state, action) => {
      const id = action.payload;
      return {
         ...state,
         pagesList: state.pagesList.map(page => {
            const { ...elm } = page
            if(elm.id === id){
               elm.is_active = !elm.is_active
            }
            return elm
         }),
      }
   },

   [types.FETCH_PAGE_DIFFERENT_ACCESS_COMPLETED]: (state, action) => {
      return {
         ...state,
         currentPage: {
            ...state.currentPage,
            ...action.payload,
            uuid: CREATE_PAGE_SEGMENT_KEY,
            is_published: true,
         },
         // leftSideFetching: false,
         // selectedPagesState: {
         //    ...state.selectedPagesState,
         //    'new': {
         //       name: 'Untitled',
         //       icon: 'home',
         //       is_published: true,
         //       ...action.payload,
         //    },
         // },
      }
   },
   [types.PUBLISH_DRAFT_CONTENT_REQUEST]: (state, action) => {
      return {
         ...state,
         fetchPublishDraftContent: action.payload,
      }
   },
   [types.UPDATE_PAGE_COMPLETED]: (state, action) => {
      const { id, data } = action.payload
      return {
         ...state,
         fetchSaveAsDraft: false,
         savedData: {},
         pagesList: state.pagesList.map(page => {
            let { ...elm } = page
            if(elm.id === id){
               elm = {
                  ...elm,
                  ...data,
               }
            }
            return elm
         }),
      }
   },
   [types.FETCH_SAVE_AS_DRAFT_REQUEST]: (state, action) => {
      return {
         ...state,
         fetchSaveAsDraft: action.payload,
      }
   },
   [types.UPDATE_PAGE_SECTIONS_COMPLETED]: (state, action) => {
      const { uuid, data, isMeta } = action.payload;
      let oldSection = state.pageSections?.[uuid] || {};
      let newState = {
         ...data,
      }
      if(isMeta){
         const oldMetas = oldSection.metas || {};
         newState = {
            metas: {
               ...oldMetas,
               ...data,
            },
         }
      }
      return {
         ...state,
         pageSections: {
            ...state.pageSections,
            [uuid]: {
               ...oldSection,
               ...newState,
            },
         },
      }
   },
   [types.UPDATE_PAGE_SECTIONS_ORDER]: (state, action) => {
      const data = action.payload;
      let uuids = Object.keys(data).sort(function(a, b){ return data[a] - data[b] })

      const { pageSections } = state;
      let oldSection = {}
      uuids.forEach(uuid => {
         if(pageSections[uuid]){
            oldSection[uuid] = {
               ...pageSections[uuid],
               order: data[uuid],
            }
         }
      });
      return {
         ...state,
         pageSections: oldSection,
      }
   },
   [types.UPDATE_CURRENT_SECTION_UUID_COMPLETED]: (state, action) => {
      return {
         ...state,
         currentSectionUuid: action.payload,
      }
   },
   [types.STATE_UPDATE_ACTION]: (state, action) => {
      return {
         ...state,
         ...action.payload,
      }
   },
   [types.DELETE_SECTION_COMPLETED]: (state, action) => {
      const { id, isDeleted, sectionUuid } = action.payload;
      const sections = state.currentPage?.sections || [];
      let pageSections = {
         ...state.pageSections,
      }
      if(pageSections?.[sectionUuid]){
         pageSections = {
            ...pageSections,
            [sectionUuid]: {
               ...pageSections[sectionUuid],
               is_deleted: Boolean(isDeleted),
            },
         }
      }
      return {
         ...state,
         currentPage: {
            ...state.currentPage,
            sections: sections.map(page => {
               const { ...elm } = page
               if(elm.id === id){
                  elm.is_deleted = Boolean(isDeleted)
               }
               return elm
            }),
         },
         pageSections,
      }
   },
   [types.TOGGLE_VISIBILITY_SECTIONS_COMPLETED]: (state, action) => {
      const { id, sectionUuid } = action.payload;
      const sections = state.currentPage?.sections || [];
      let pageSections = {
         ...state.pageSections,
      }
      if(pageSections?.[sectionUuid]){
         pageSections = {
            ...pageSections,
            [sectionUuid]: {
               ...pageSections[sectionUuid],
               is_active: !Boolean(pageSections[sectionUuid]?.is_active),
            },
         }
      }
      console.log(pageSections[sectionUuid])
      return {
         ...state,
         currentPage: {
            ...state.currentPage,
            sections: sections.map(page => {
               const { ...elm } = page
               if(elm.id === id){
                  elm.is_active = !elm.is_active
               }
               return elm
            }),
         },
         pageSections,
      }
   },
   [types.RESTOR_GLOBAL_SETTINGS_ACTION]: (state, action) => {
      return {
         ...state,
         globalSettings: state.reservGlobalSettings,
      }
   },
   [types.RESTOR_PAGE_SECTIONS_ACTION]: (state, action) => {
      return {
         ...state,
         pageSections: state.reservPageSections,
      }
   },
   [types.RESTOR_CURRENT_PAGE_ACTION]: (state, action) => {
      return {
         ...state,
         currentPage: state.reservCurrentPage,
      }
   },
   [types.SET_UPDATE_CONTENT_RESOURCES]: (state, action) => {
      return {
         ...state,
         contentResources: {
            ...state.contentResources,
            ...action.payload,
         },
      }
   },

   [types.SET_CURRENT_SEGMENT_ACTION]: (state, action) => {
      return {
         ...state,
         currentSegment: action.payload,
      }
   },
   [types.UPDATE_GLOBAL_SETTINGS_COMPLETED]: (state, action) => {
      const { type, data, bool } = action.payload;
      const settings = state.globalSettings?.[type] || [];
      let newState = {
         globalSettings: {
            ...state.globalSettings,
            [type]: {
               ...settings,
               ...data,
            },
         },
      }
      if(bool){
         newState = {
            ...newState,
            reservGlobalSettings: {
               ...state.reservGlobalSettings,
               [type]: {
                  ...settings,
                  ...data,
               },
            },
         }

      }
      return {
         ...state,
         ...newState,
      }
   },

   [types.SET_PREPEAR_COMPONENT_FOR_RENDER]: (state, action) => {
      return {
         ...state,
         prepearComponentForRender: {
            ...state.prepearComponentForRender,
            ...action.payload,
         },
      }
   },
};

export default createReducer(initialState)(reducersMap);
